import React from "react";

const ContactInformation = () =>
  <section>
    <ul className="contact">
      <li>
        <h3>Address</h3>
        <span>
          Pursimiehenkatu 2
          <br />
          00150 Helsinki
          <br />
          Finland
        </span>
      </li>
      <li>
        <h3>Email</h3>
        <a href="mailto:sausage@feris.fi">sausage@feris.fi</a>
      </li>
      <li>
        <h3>Phone</h3>
        <span>+358 2044 205412546</span>
      </li>
      <li>
        <h3>Social</h3>
        <ul className="icons">
          <li>
            <a target="_blank" href="https://www.facebook.com/ferissausages/?__tn__=%2Cd%2CP-R&eid=ARBE6uH43pq9ZHZYfbkMZQU_RrSqtt28B8S_OrpO3GkHyPVSKHz1byXNhQA18wtwiTbLzTQdPr3roOWd" className="fa-facebook">
              <span className="label">Facebook</span>
            </a>
          </li>
          <li>
            <a target="_blank" href="https://www.instagram.com/ferissausages/" className="fa-instagram">
              <span className="label">Instagram</span>
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </section>

export default ContactInformation;
